import React from 'react';
import { getStatusColors } from './colors';

/**
 * Badge component that displays a status badge with colors from colors.js
 * @param {string} status - The status type (e.g., 'success', 'failed', 'info', etc.)
 * @param {string} title - The text to display in the badge
 * @param {string} className - Additional CSS classes to apply
 * @returns {JSX.Element} A badge element
 */
export const renderStatusBadge = ({ status, title, className = '' }) => {
  // Get color mapping from colors.js
  const colors = getStatusColors(status);
  
  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 14px', // More generous padding like the image
    borderRadius: '20px', // Fully rounded pill shape
    fontSize: '12px', // text-sm
    fontWeight: '600', // Regular weight, not too bold
    backgroundColor: colors.bgColor || colors.bgClass || '#F5F5F5',
    color: colors.textColor || colors.textClass || '#424242',
    whiteSpace: 'nowrap',
    lineHeight: '1.2',
    border: 'none', // No border
  };

  return (
    <span style={badgeStyle} className={className}>
      {title || status}
    </span>
  );
};

/**
 * Helper function to get badge configuration for a given status
 * @param {string} status - The status value
 * @returns {Object} Object with title and status
 */
export const getBadge = (status) => {
  // Capitalize first letter of status for title
  const title = status ? status.charAt(0).toUpperCase() + status.slice(1) : '';
  
  return {
    title,
    status: status?.toLowerCase() || 'default'
  };
};

export default renderStatusBadge;

